import {Component, EventEmitter, Inject, Output, OnInit} from 'ng-metadata/core';
import {SearchFieldsService} from '../../search/search.fields.service';
import {NewspapersService} from '../newspapers.service';
import {MediaQueries} from '../../infra/mediaQueries.service';
import {getSearchScopesMap, getVid, updateSearchScopesMap} from '../../appConfig/appConfigForward';
import {MappingTablesCache} from "../../mappingTablesCache/mappingTablesCache.service";

@Component({
    selector: 'prm-newspapers-search-bar',
    templateUrl: 'components/newspapers/newspapersSearchBar/newspapers-search-bar.html',
})

export class PrmNewspapersSearchBar{

    @Output() private searchEvent = new EventEmitter();
    private FEATURED_NAME_LENGTH_LIMIT = 35;

    private focusOnSearchInput: boolean = false;
    private vid = getVid();

    constructor(@Inject('searchBoxIcons') private searchBoxIcons: Object[],
                @Inject('$stateParams') private $stateParams,
                private searchFieldsService: SearchFieldsService,
                private newspapersService: NewspapersService,
                private mediaQueries: MediaQueries,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$element') private $element,
                private mtCache: MappingTablesCache) {
         
        if (this.$stateParams.featured_scope) {
            this.featuredScope = this.$stateParams.featured_scope;
            this.newspapersService.cameFromFeaturedSearch = true;
            this.newspapersService.featuredTitle = this.featuredScope;
            this.newspapersService.featuredDescription = this.newspapersService.nameDescMap[this.featuredScope];
        }
        
        /*  PRM-40017
            Newspaper - After selecting Featured Newspapers at the scope should be Featured newspaper but was:Newspapers
        */
        this.scope = this.$stateParams.search_scope || newspapersService.DEFAULT_SCOPE;

        this.focusOnSearchInput = (this.mtCache.getTable(this.mtCache.tables.VIEW_PROPERTIES).filter((row) => row.source1 === this.vid && row.source2 === 'focus_on_search_input' && row.target === 'true').length === 1);
       
    }

    ngOnInit(){
        this.$scope.$watch(()=>this.mainSearchField, (newVal,oldVal)=>{
            this.$timeout(() => {
                this.removeAriaLabel('md-input-container input');
            }, 400);
        });

        // Set autofocus to input search bar
        this.$timeout(() => {
            if (this.mediaQueries.gtmd && this.focusOnSearchInput) {
                let elem = document.querySelector('#searchBar');
                if (elem) {
                    elem.focus();
                }
            }
        }, 0);
    }
    
    private onSubmit() {
        if (this.mainSearchField) {
            let eventData = {
                mainSearchField: 'any,contains,' + this.mainSearchField,
                scopeField: this.scope,
                featuredScopeField: undefined,
                mode: undefined,
                issn: undefined,
                facet: undefined,
                mfacet: undefined,
                pfilter: undefined
            };
            this.newspapersService.cameFromFeaturedSearch = false;
            this.newspapersService.featuredTitle = '';
            this.newspapersService.featuredDescription = '';
            if (this.scope === 'featured') {
                eventData.featuredScopeField = this.featuredScope;
                eventData.issn = this.newspapersService.nameIssnMap[this.featuredScope];
                this.newspapersService.cameFromFeaturedSearch = true;
                this.newspapersService.featuredTitle = this.featuredScope;
                this.newspapersService.featuredDescription = this.newspapersService.nameDescMap[this.featuredScope];
            }
            this.searchEvent.emit(eventData);
        }

        // Only for mobile -  This for auto-closing of the keyboard when the user clicks search from the mobile keyboard button
        if (!this.mediaQueries.gtmd) {
            document.getElementById("searchBar").blur();
        }
    }

    get mainSearchField() {
        return this.searchFieldsService.mainSearch;
    }

    set mainSearchField(mainSearchField) {
        this.searchFieldsService.mainSearch = mainSearchField;
    }
    
    private displayFeaturedNespapersDropDown() {
        return this.newspapersService.displayFeaturedNewspapers();
    }

    private get scopes() {
        return this.newspapersService.scopes;
    }

    private get featuredScopes() {
        return this.newspapersService.featuredScopes;
    }

    private get featuredScope() {
        return this.newspapersService.featuredScope;
    }

    private set featuredScope(featuredScope) {
        this.newspapersService.featuredScope = featuredScope;
    }

    private get scope() {
        return this.newspapersService.scope;
    }

    private set scope(scope) {
        this.newspapersService.scope = scope;
    }

    //this function remove aria-label from search edit field.
    private removeAriaLabel(str){
        let searchEditField: [Element]= this.$element[0].querySelectorAll(str);
        for(let input of searchEditField){
            input.removeAttribute('aria-label');
        }
    }

    private clear() {
        this.mainSearchField = '';
        document.querySelector('#searchBar').focus();
    }

    private get showFeaturedOptions() {
        return this.scope === 'featured';
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/newspapersSearchBar/newspapersSearchBar.directive.ts